import { useState, useEffect } from "react";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleConsent = (type) => {
    localStorage.setItem("cookieConsent", type);
    setShowBanner(false);
  };

  return (
    showBanner && (
      <div className="cookie-banner">
        <p>Este site usa cookies para melhorar sua experiência. Escolha suas preferências:</p>
        <div className="button-container">
          <button onClick={() => handleConsent("all")}>Aceitar Todos</button>
          <button onClick={() => handleConsent("essential")}>Apenas Essenciais</button>
          <button onClick={() => handleConsent("marketing")}>Aceitar Estatísticas & Marketing</button>
        </div>
      </div>
    )
  );
};

export default CookieBanner;
